"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postNewReport = exports.fetchDeleteMascota = exports.updateMascota = exports.fetchMiMascotaById = exports.postNuevaMascota = exports.fetchMisMascotas = exports.fetchUserData = exports.fetchUpdateUser = exports.fetchSignup = exports.fetchLogin = exports.isExistingEmail = exports.fetchPetById = exports.fetchMascotasCercanas = void 0;
var API_BASE_URL = "https://apx-pets.herokuapp.com";
//const API_BASE_URL = "http://localhost:3003";
function fetchMascotasCercanas(currentLocation) {
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL +
                        "/pets-cerca-de?lat=" +
                        currentLocation.lat +
                        "&lng=" +
                        currentLocation.lng)];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
exports.fetchMascotasCercanas = fetchMascotasCercanas;
function fetchPetById(id) {
    return __awaiter(this, void 0, void 0, function () {
        var res, petHit;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/pets/" + parseInt(id))];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    petHit = _a.sent();
                    return [2 /*return*/, petHit];
            }
        });
    });
}
exports.fetchPetById = fetchPetById;
function isExistingEmail(email) {
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/auth/" + email)];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
exports.isExistingEmail = isExistingEmail;
function fetchLogin(email, password) {
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/auth/token", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                            email: email,
                            password: password,
                        }),
                    })];
                case 1:
                    res = _a.sent();
                    if (!(res.status == 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data.token];
                case 3: return [2 /*return*/, false];
            }
        });
    });
}
exports.fetchLogin = fetchLogin;
function fetchSignup(email, name, password) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/auth", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                            email: email,
                            password: password,
                            fullName: name,
                        }),
                    })];
                case 1:
                    res = _a.sent();
                    if (res.status == 200) {
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.fetchSignup = fetchSignup;
function fetchUpdateUser(email, name, password) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/auth", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                            email: email,
                            password: password,
                            fullName: name,
                        }),
                    })];
                case 1:
                    res = _a.sent();
                    if (res.status == 200) {
                        return [2 /*return*/, res];
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.fetchUpdateUser = fetchUpdateUser;
function fetchUserData(token) {
    return __awaiter(this, void 0, void 0, function () {
        var res, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/me", {
                        headers: {
                            Authorization: "bearer " + token,
                        },
                    })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    user = _a.sent();
                    return [2 /*return*/, user];
            }
        });
    });
}
exports.fetchUserData = fetchUserData;
function fetchMisMascotas(token) {
    return __awaiter(this, void 0, void 0, function () {
        var res, mascotas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/me/pets", {
                        headers: {
                            Authorization: "bearer " + token,
                        },
                    })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    mascotas = _a.sent();
                    return [2 /*return*/, mascotas];
            }
        });
    });
}
exports.fetchMisMascotas = fetchMisMascotas;
function postNuevaMascota(petData, token) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/pets", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "bearer " + token,
                        },
                        body: JSON.stringify(petData),
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    });
}
exports.postNuevaMascota = postNuevaMascota;
function fetchMiMascotaById(petId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var res, mascota;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/me/pets/" + petId, {
                        headers: {
                            Authorization: "bearer " + token,
                        },
                    })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    mascota = _a.sent();
                    return [2 /*return*/, mascota];
            }
        });
    });
}
exports.fetchMiMascotaById = fetchMiMascotaById;
function updateMascota(updateData, petId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/pets/" + petId, {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "bearer " + token,
                        },
                        body: JSON.stringify(updateData),
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    });
}
exports.updateMascota = updateMascota;
function fetchDeleteMascota(petId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/pets/" + petId, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "bearer " + token,
                        },
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    });
}
exports.fetchDeleteMascota = fetchDeleteMascota;
function postNewReport(reportData) {
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/report", {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json",
                        },
                        body: JSON.stringify(reportData),
                    })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
exports.postNewReport = postNewReport;
